// extracted by mini-css-extract-plugin
var _1 = "BsfxNdiMVwhknni2clqR";
var _2 = "meUqULxGxR5C_jUgFKor";
var _3 = "EiZx8BkWrGwAEfO9JD7A";
var _4 = "#000000";
var _5 = "#76F366";
var _6 = "#EB8632";
var _7 = "#ECC834";
var _8 = "#21FC87";
var _9 = "#EA4A30";
var _a = "#C7EA45";
var _b = "#272B2B";
var _c = "#BDBDBD";
var _d = "#7D7D7D";
var _e = "#6A0DAD";
var _f = "#3A65FF";
var _10 = "#4A90E2";
var _11 = "#ffffff";
var _12 = "i31CON030aM8OIfPl9Rr";
var _13 = "mtYgzlD_3G1C4XcGjFrb";
var _14 = "KasCpKHqxtHBOWjzenzQ";
var _15 = "B8riOtwt90XhmMd8ZnA5";
var _16 = "PZLPIUODlynqhnDJVL8E";
var _17 = "tBMD_n3sqUI_x5PwkQ6h";
var _18 = "BCPG1fJzJgTjCqBFBhF0";
var _19 = "IIywfZWWqr6EcZuZd_1h";
var _1a = "BDmJOIbCNEyGAUKi4Sb3";
var _1b = "KhfAqi86nWZsrHlJVTwi";
var _1c = "1200px";
var _1d = "992px";
var _1e = "1366px";
var _1f = "768px";
var _20 = "1475px";
var _21 = "576px";
var _22 = "1600px";
var _23 = "320px";
var _24 = "2500px";
var _25 = "Zr1Otlkv8jBo9L0AoEiw";
export { _1 as "active-media-preview", _2 as "base-link", _3 as "clear", _4 as "colorBlack", _5 as "colorGradeEX", _6 as "colorGradeFR", _7 as "colorGradeGD", _8 as "colorGradeOU", _9 as "colorGradePR", _a as "colorGradeVG", _b as "colorNeutral", _c as "colorNeutralLighest", _d as "colorNeutralLight", _e as "colorNonOwnerSweetLine", _f as "colorOwnerSweetLine", _10 as "colorRegularLinks", _11 as "colorWhite", _12 as "fancyInput", _13 as "fancyInputError", _14 as "fancyInputErrorText", _15 as "fancyInputHasIcon", _16 as "fancyInputHasSuffix", _17 as "fancyInputIcon", _18 as "fancyInputSuccess", _19 as "fancyInputSuccessText", _1a as "fancySuffix", _1b as "reset-button", _1c as "screenlg", _1d as "screenmd", _1e as "screenml", _1f as "screensm", _20 as "screenxlg", _21 as "screenxs", _22 as "screenxxlg", _23 as "screenxxs", _24 as "screenxxxlg", _25 as "single-page-responsive-font-size" }
export default { "active-media-preview": _1, "base-link": _2, "clear": _3, "colorBlack": _4, "colorGradeEX": _5, "colorGradeFR": _6, "colorGradeGD": _7, "colorGradeOU": _8, "colorGradePR": _9, "colorGradeVG": _a, "colorNeutral": _b, "colorNeutralLighest": _c, "colorNeutralLight": _d, "colorNonOwnerSweetLine": _e, "colorOwnerSweetLine": _f, "colorRegularLinks": _10, "colorWhite": _11, "fancyInput": _12, "fancyInputError": _13, "fancyInputErrorText": _14, "fancyInputHasIcon": _15, "fancyInputHasSuffix": _16, "fancyInputIcon": _17, "fancyInputSuccess": _18, "fancyInputSuccessText": _19, "fancySuffix": _1a, "reset-button": _1b, "screenlg": _1c, "screenmd": _1d, "screenml": _1e, "screensm": _1f, "screenxlg": _20, "screenxs": _21, "screenxxlg": _22, "screenxxs": _23, "screenxxxlg": _24, "single-page-responsive-font-size": _25 }
